// Opportunities — categories + cards are rendered server-side from PHP.
// JS only handles category filtering (show/hide by data-category) and the
// horizontal scroll buttons.
document.addEventListener('DOMContentLoaded', function () {
    var cardsWrapper = document.querySelector('.opportunities__cards-wrapper');
    var cardsTrack   = document.querySelector('.opportunities__cards');
    var leftBtn      = document.querySelector('.scroll-nav--left');
    var rightBtn     = document.querySelector('.scroll-nav--right');
    var catButtons   = document.querySelectorAll('.opportunities__categories .cat-btn');

    if (!cardsWrapper || !cardsTrack || !leftBtn || !rightBtn) return;

    var allCards = Array.prototype.slice.call(cardsTrack.querySelectorAll('.opp-card'));

    // ---- Filter ----
    function applyFilter(slug) {
        cardsTrack.style.opacity   = '0';
        cardsTrack.style.transform = 'translateY(8px)';

        setTimeout(function () {
            allCards.forEach(function (card) {
                var match = !slug || slug === 'all' || card.getAttribute('data-category') === slug;
                card.style.display = match ? '' : 'none';
            });

            cardsWrapper.scrollLeft = 0;

            requestAnimationFrame(function () {
                cardsTrack.style.opacity   = '1';
                cardsTrack.style.transform = 'translateY(0)';
            });

            updateButtonVisibility();
        }, 150);
    }

    catButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            catButtons.forEach(function (b) { b.classList.remove('active'); });
            btn.classList.add('active');
            applyFilter(btn.getAttribute('data-category'));
        });
    });

    // ---- Scroll ----
    var scrollAmount = 500;

    leftBtn.addEventListener('click', function () {
        cardsWrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    rightBtn.addEventListener('click', function () {
        cardsWrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    function updateButtonVisibility() {
        var scrollLeft  = cardsWrapper.scrollLeft;
        var scrollWidth = cardsWrapper.scrollWidth;
        var clientWidth = cardsWrapper.clientWidth;

        if (scrollLeft <= 0) {
            leftBtn.style.opacity       = '0.5';
            leftBtn.style.pointerEvents = 'none';
        } else {
            leftBtn.style.opacity       = '1';
            leftBtn.style.pointerEvents = 'auto';
        }

        if (scrollLeft + clientWidth >= scrollWidth - 10) {
            rightBtn.style.opacity       = '0.5';
            rightBtn.style.pointerEvents = 'none';
        } else {
            rightBtn.style.opacity       = '1';
            rightBtn.style.pointerEvents = 'auto';
        }
    }

    cardsWrapper.addEventListener('scroll', updateButtonVisibility);
    cardsTrack.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
    updateButtonVisibility();

    // Honour the initially-active category from server-render
    var initialActive = document.querySelector('.opportunities__categories .cat-btn.active');
    if (initialActive) {
        applyFilter(initialActive.getAttribute('data-category'));
    }
});
